const app_modules = {
  dashboard: {
    app_name: "Dashboard",
    modules: {
      overview: "Overview",
    },
  },
  user_management: {
    app_name: "User Management",
    modules: {
      organisation: "Organisation",
      department: "Department",
      team: "Team",
      userType: "User Type",
      user: "User",
      module: "Module",
      settings: "Settings",
    },
  },
  master: {
    app_name: "Masters",
    modules: {
      category: "Category",
      subcategory: "Sub Category",
      type: "Type",
      unit: "Unit",
      gst: "GST",
      hsn_code: "HSN Code",
      sac_code: "SAC Code",
      currency: "Currency",
      make: "Make",
      model: "Model",
      product: "Product",
      customer: "Customer",
      warehouse: "Warehouse",
      supplier: "Supplier",
      terms_and_conditions: "Terms And Conditions",
    
    },
  },
  enquiry: {
    app_name: "Enquiry",
    modules: {
      product: "Product",
      service: "Service",
    },
  },
  quotation: {
    app_name: "Quotation",
    modules: {
      product: "Product",
      service: "Service",
    },
  },
  sales_order: {
    app_name: "Sales Order",
    modules: {
      product: "Product",
      service: "Service",
    },
  },
  purchase_management: {
    app_name: "Purchase Management",
    modules: {
      purchase_request: "Purchase Request",
      purchase_order: "Purchase Order",
    },
  },
  inventory: {
    app_name: "Inventory",
    modules: {
      in_stock: "In Stock",
      reorder_level: "Reorder Level",
    },
  },
  warehouse: {
    app_name: "Warehouse",
    modules: {
      stock_overview: "Stock Overview",
      item_inward: "Item Inward",
      packing: "Packing",
      dispatch: "Dispatch",
    },
  },
  payment_management: {
    app_name: "Payment Management",
    modules: {
      product: "Product",
      service: "Service",
    },
  },
};

const action_options = {
  create: "Create",
  view: "View",
  update: "Update",
};

export { app_modules, action_options };
